import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const GoogleIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#google_svg__a)">
      <path
        fill="#FBBB00"
        d="m4.867 12.086-.729 2.598-2.664.054A9.6 9.6 0 0 1 .227 10c0-1.658.422-3.222 1.17-4.599l2.372.416 1.039 2.251a5.7 5.7 0 0 0 .059 4.018"
      />
      <path
        fill="#518EF8"
        d="M20.98 8.132q.181.91.183 1.868-.001 1.076-.229 2.088c-.51 2.292-1.84 4.294-3.685 5.71l-2.988-.146-.423-2.52a6.04 6.04 0 0 0 2.685-3.044h-5.598V8.132H20.98"
      />
      <path
        fill="#28B446"
        d="M17.248 17.798A10.73 10.73 0 0 1 10.696 20c-3.987 0-7.453-2.129-9.221-5.261l3.392-2.653c.884 2.254 3.16 3.858 5.829 3.858a6.4 6.4 0 0 0 3.143-.813z"
      />
      <path
        fill="#F14336"
        d="m17.377 2.302-3.392 2.652a6.4 6.4 0 0 0-3.29-.899c-2.73 0-5.048 1.678-5.888 4.013l-3.41-2.667C3.138 2.192 6.648 0 10.694 0c2.54 0 4.869.864 6.682 2.302"
      />
    </g>
    <defs>
      <clipPath id="google_svg__a">
        <path fill="#fff" d="M.227 0h20.938v20H.227z" />
      </clipPath>
    </defs>
  </ChakraIcon>
);
